/** Agrupa solicitudes del mismo trabajador, tipo y día del fichaje; ordena por más recientes primero. */

export const TIPOS_AGRUPABLES = new Set([
  "fichaje_manual",
  "fuera_horario",
  "modificacion_fichaje",
]);

export function diaSolicitud(s) {
  return s.timestamp_solicitado?.slice(0, 10) || s.fecha_inicio;
}

/** Clave ISO para ordenar por actividad más reciente (creación, revisión o fecha del hecho). */
export function sortRecienteSolicitud(s) {
  return (
    s.revisado_en
    || s.created_at
    || s.timestamp_solicitado
    || s.timestamp_real
    || `${s.fecha_inicio}T12:00:00`
  );
}

export function itemsPorDia(items) {
  const map = new Map();
  for (const s of items) {
    const d = diaSolicitud(s);
    if (!map.has(d)) map.set(d, []);
    map.get(d).push(s);
  }
  return [...map.entries()].sort(([a], [b]) => b.localeCompare(a));
}

/** Devuelve entradas { kind: 'single'|'group', ... } ordenadas por más recientes primero. */
export function agruparSolicitudes(lista) {
  const sueltos = [];
  const map = new Map();

  for (const s of lista) {
    if (!TIPOS_AGRUPABLES.has(s.tipo)) {
      sueltos.push({
        kind: "single",
        item: s,
        sortReciente: sortRecienteSolicitud(s),
        sortUsuario: s.usuario || "",
      });
      continue;
    }
    const dia = diaSolicitud(s);
    const key = `${s.usuario_id}:${s.tipo}:${dia}`;
    if (!map.has(key)) {
      map.set(key, {
        kind: "group",
        key,
        dia,
        usuario_id: s.usuario_id,
        usuario: s.usuario,
        departamento: s.departamento,
        tipo: s.tipo,
        tipo_label: s.tipo_label,
        estado: s.estado,
        items: [],
      });
    }
    map.get(key).items.push(s);
  }

  const salida = [];
  for (const g of map.values()) {
    g.items.sort((a, b) => sortRecienteSolicitud(b).localeCompare(sortRecienteSolicitud(a)));
    if (g.items.length === 1) {
      const s = g.items[0];
      sueltos.push({
        kind: "single",
        item: s,
        sortReciente: sortRecienteSolicitud(s),
        sortUsuario: s.usuario || "",
      });
    } else {
      salida.push({
        ...g,
        sortReciente: sortRecienteSolicitud(g.items[0]),
        sortUsuario: g.usuario || "",
      });
    }
  }

  salida.push(...sueltos);
  salida.sort((a, b) => {
    const cmp = b.sortReciente.localeCompare(a.sortReciente);
    if (cmp !== 0) return cmp;
    if (a.sortUsuario !== b.sortUsuario) return a.sortUsuario.localeCompare(b.sortUsuario);
    if (a.kind === "group" && b.kind === "single") return -1;
    if (a.kind === "single" && b.kind === "group") return 1;
    return 0;
  });
  return salida;
}
